import showModal from './showModal';
import showOverpanel from './showOverpanel';
import closeOverpanel from './closeOverpanel';
import showAlert from './showAlert';
import { showLoadingModal, clearLoadingModal } from './loadingModal';
import shareText from './shareText';
import setTitle from './setTitle';
import setParams from './setParams';
import clearParams from './clearParams';
import setFetching from './setFetching';
import printWindow from './printWindow';
import navigateTo from './navigateTo';
import keepAlive from './keepAlive';
import scrollToTop from './scrollToTop';
import openURL from './openURL';
import openApp from './openApp';
import openModule from './openModule';
import SDKMessageBus from '../utility/message-bus';
import notifyRefetchAccounts from './notifyRefetchAccounts';
import clearCache from './clearCache';
import logToServer from './logToServer';
import manageChanges from './manageChanges';
import { unenrollPush, enrollPush } from './pushEnrollment';
import { actionRequired, removeActionRequired } from './actionRequired';
import { IActions, TectonWindow } from '../types';

export default function setupActions(
    messageBus: SDKMessageBus,
    moduleId: string,
    teardowns: (() => void)[],
    platformCapabilities: Set<string>,
    resizeIframe: () => void
): IActions {
    const actions: IActions = {
        showOverpanel: showOverpanel(messageBus, moduleId, platformCapabilities),
        closeOverpanel: closeOverpanel(platformCapabilities),
        showModal: showModal(messageBus, platformCapabilities),
        showAlert: showAlert(platformCapabilities),
        navigateTo: navigateTo(platformCapabilities, moduleId),
        shareText: shareText(messageBus, platformCapabilities),
        setTitle: setTitle(moduleId, platformCapabilities),
        setParams: setParams(moduleId, platformCapabilities),
        clearParams: clearParams(moduleId, platformCapabilities),
        notifyRefetchAccounts: notifyRefetchAccounts(platformCapabilities),
        clearCache: clearCache(messageBus, platformCapabilities),
        showLoadingModal: showLoadingModal(platformCapabilities),
        clearLoadingModal: clearLoadingModal(platformCapabilities),
        setFetching: setFetching(moduleId),
        printWindow,
        manageChanges: manageChanges(messageBus, platformCapabilities),
        logToServer: logToServer(platformCapabilities, moduleId),
        scrollToTop: scrollToTop(moduleId, platformCapabilities),
        openURL: openURL(platformCapabilities),
        openApp: openApp(messageBus, platformCapabilities),
        openModule: openModule(messageBus, platformCapabilities),
        keepAlive: keepAlive(platformCapabilities),
        unenrollPush: unenrollPush(messageBus, platformCapabilities),
        enrollPush: enrollPush(messageBus, platformCapabilities),
        actionRequired: actionRequired(moduleId, platformCapabilities),
        removeActionRequired: removeActionRequired(moduleId, platformCapabilities),
        resizeIframe
    };
    if ((window as TectonWindow)?.Tecton?.inMobileApp === true) {
        delete actions.printWindow;
    }
    return actions;
}
